<template>
    <Card
        class="max-w-xl"
    >
        <CustomerForm
            :value="customer"
            :errors="errors"
            @submit="updateCustomer"
        />
    </Card>
</template>

<script>
import CustomerForm from '@/components/customers/CustomerForm.vue';
import resourceMixin from '@/mixins/resourceMixin';

export default  {
    name: 'CustomerEdit',
    components: {
        CustomerForm,
    },
    mixins: [resourceMixin('customers')],
};
</script>

<style></style>
